module.exports = __webpack_public_path__ + "img/online-course.be75ab20.svg";